import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { environment } from '../../../../../../../environments/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { ContaConfigRequest, ContaConfigResponse } from './conta-config.model';

@Injectable({ providedIn: 'root' })
export class ContaConfigService extends BaseService {
    private readonly PATH = SICOM_PATHS.financeiro.arrecadacao.contaConfig;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /** Configuração contábil da UF (o backend devolve linha vazia quando a UF ainda não tem registro). */
    buscar(uf: string): Observable<ContaConfigResponse> {
        return this.http.get<ContaConfigResponse>(`${this.rootUrl}${this.PATH}/${encodeURIComponent(uf)}`);
    }

    salvar(request: ContaConfigRequest): Observable<ContaConfigResponse> {
        return this.http.post<ContaConfigResponse>(`${this.rootUrl}${this.PATH}`, request);
    }
}
